import { useEffect, useState } from "react";
import { getMyLeadsApi, getLeadsByUserIdApi, syncLeadsNowApi, getLeadDetailsApi, updateLeadStageApi, updateLeadRemarkApi, createLeadViewHistoryApi, getLeadActivityApi, createLeadActivityLogApi, getNewLeadsApi } from "../apiServices/leadServices";

const useLeads = (params = {}) => {
  const [activities,setActivities]=useState([]);
  const [activityLoading,setActivityLoading]=useState(false);
  const [activityPagination,setActivityPagination]=useState({});
  const [leads, setLeads] = useState([]);
  const [syncLoading,setSyncLoading]=useState(false);
  const [leadDetails, setLeadDetails] = useState(null);
  const [userName,setUserName]=useState("");
  const [loading, setLoading] = useState(false);
  const [pagination, setPagination] = useState({ page: 1, totalPages: 1, total: 0, });
  const setPaginationData = (data) => { setPagination({ page: data?.page || 1, totalPages: data?.totalPages || 1, total: data?.total || 0, }); };

  const syncLeadsNow=async()=>{
    try{
      setSyncLoading(true);
      const response=await syncLeadsNowApi();
      return response;
    }catch(error){
      console.error(error);
      throw error;
    }finally{
      setSyncLoading(false);
    }
  };


  const fetchMyLeads = async (queryParams = params, forceRefresh = false) => {
    const cacheKey = `my_leads_cache_${JSON.stringify(queryParams || {})}`;
    let hasCache = false;
    try {
      if (!forceRefresh) {
        try {
          const cached = sessionStorage.getItem(cacheKey);
          if (cached) {
            const parsed = JSON.parse(cached);
            if (Array.isArray(parsed.leads)) {
              setLeads(parsed.leads);
              setPaginationData(parsed.pagination || {});
              setLoading(false);
              hasCache = true;
            }
          }
        } catch (e) {}
      }

      if (!hasCache || forceRefresh) setLoading(true);

      const data = await getMyLeadsApi(queryParams);
      const newLeads = data?.data?.leads || [];
      const newPag = data?.data || {};

      setLeads(newLeads);
      setPaginationData(newPag);

      try {
        sessionStorage.setItem(cacheKey, JSON.stringify({ leads: newLeads, pagination: newPag }));
      } catch (e) {}
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  const fetchNewLeads = async (queryParams = params, forceRefresh = false) => {
    const cacheKey = `new_leads_cache_${JSON.stringify(queryParams || {})}`;
    let hasCache = false;
    try {
      if (!forceRefresh) {
        try {
          const cached = sessionStorage.getItem(cacheKey);
          if (cached) {
            const parsed = JSON.parse(cached);
            if (Array.isArray(parsed.leads)) {
              setLeads(parsed.leads);
              setPaginationData(parsed.pagination || {});
              setLoading(false);
              hasCache = true;
            }
          }
        } catch (e) {}
      }

      if (!hasCache || forceRefresh) setLoading(true);

      const data = await getNewLeadsApi(queryParams);
      const newLeads = data?.data?.leads || [];
      const newPag = data?.data || {};

      setLeads(newLeads);
      setPaginationData(newPag);

      try {
        sessionStorage.setItem(cacheKey, JSON.stringify({ leads: newLeads, pagination: newPag }));
      } catch (e) {}
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  const fetchLeadsByUserId = async (userId, query = "") => {
    try {
      setLoading(true);
      const response = await getLeadsByUserIdApi(userId, query);
      const data = response?.data || {};
      setLeads(data?.leads || []);
      setUserName(data?.userName || "");
      setPagination({
        page: data?.page || 1,
        total: data?.total || 0,
        totalPages: data?.totalPages || 1,
      });
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  const fetchLeadDetails = async (source,leadId) => {
    try {
      setLoading(true);
      const response = await getLeadDetailsApi(source,leadId);
      const data = response?.data?.data || {};
      setLeadDetails(data);
      return data;
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  const clearLeadSessionCaches = () => {
    try {
      Object.keys(sessionStorage).forEach((key) => {
        if (key.startsWith("fb_leads_cache_") || key.startsWith("my_leads_cache_") || key.startsWith("new_leads_cache_")) {
          sessionStorage.removeItem(key);
        }
      });
    } catch (e) {}
  };

  const updateLeadStage = async (source, leadId, stageId, comment = "") => {
    try {
      await updateLeadStageApi(source, leadId, { stageId, comment });
      clearLeadSessionCaches();
      await fetchMyLeads(params, true);
      if (leadDetails?._id === leadId) { await fetchLeadDetails(source, leadId); }
    } catch (error) {
      console.error(error);
      throw error;
    }
  };

  const updateLeadRemark = async (source, leadId, remark) => {
    try {
      await updateLeadRemarkApi(source, leadId, { remark });
      clearLeadSessionCaches();
      if (leadDetails?._id === leadId) { await fetchLeadDetails(source, leadId); }
    } catch (error) {
      console.error(error);
    }
  };

  const createLeadViewHistory = async (source,leadId) => {
    try {
      await createLeadViewHistoryApi(source,leadId);
    } catch (error) {
      console.error(error);
    }
  };
  const fetchLeadActivity=async( source,leadId, params={} )=>{
    try{
      setActivityLoading(true);
      const res= await getLeadActivityApi( source,leadId, params );
      setActivities( res?.data?.data?.records || [] );
      setActivityPagination( res?.data?.data?.pagination || {} );
    }catch(error){
      console.error(error);
    }finally{
      setActivityLoading(false);
    }
  };
  const createLeadActivityLog = async (source, leadId, data) => {
    try {
      const response = await createLeadActivityLogApi(source, leadId, data);
      return response?.data;
    } catch (error) {
      console.error(error);
      throw error;
    }
  };
  useEffect(() => {
    if (Object.keys(params || {}).length > 0) {
      fetchMyLeads();
    }
  }, [JSON.stringify(params)]);
  return { leads, leadDetails, loading,activityLoading, userName, pagination,activities,activityPagination, fetchMyLeads, fetchNewLeads, fetchLeadsByUserId, fetchLeadDetails,createLeadActivityLog, updateLeadStage, updateLeadRemark, createLeadViewHistory,  fetchLeadActivity, clearLeadSessionCaches };
};

export default useLeads;